/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(4);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(5);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _messages = __webpack_require__(6);

	var _messages2 = _interopRequireDefault(_messages);

	var _select = __webpack_require__(7);

	var _select2 = _interopRequireDefault(_select);

	var _search = __webpack_require__(8);

	var _search2 = _interopRequireDefault(_search);

	var _jumpToTop = __webpack_require__(9);

	var _jumpToTop2 = _interopRequireDefault(_jumpToTop);

	var _emptyParagraphs = __webpack_require__(10);

	var _emptyParagraphs2 = _interopRequireDefault(_emptyParagraphs);

	var _detectIE = __webpack_require__(11);

	var _detectIE2 = _interopRequireDefault(_detectIE);

	var _archiveNav = __webpack_require__(12);

	var _archiveNav2 = _interopRequireDefault(_archiveNav);

	var _magazineArchive = __webpack_require__(13);

	var _magazineArchive2 = _interopRequireDefault(_magazineArchive);

	var _letterFilter = __webpack_require__(14);

	var _letterFilter2 = _interopRequireDefault(_letterFilter);

	var _pagination = __webpack_require__(15);

	var _pagination2 = _interopRequireDefault(_pagination);

	var _detectAdBlocker = __webpack_require__(16);

	var _detectAdBlocker2 = _interopRequireDefault(_detectAdBlocker);

	var _inputFile = __webpack_require__(17);

	var _inputFile2 = _interopRequireDefault(_inputFile);

	var _hideEmptyAds = __webpack_require__(18);

	var _hideEmptyAds2 = _interopRequireDefault(_hideEmptyAds);

	var _ajaxComplete = __webpack_require__(19);

	var _ajaxComplete2 = _interopRequireDefault(_ajaxComplete);

	var _calendar = __webpack_require__(20);

	var _calendar2 = _interopRequireDefault(_calendar);

	var _relocation = __webpack_require__(21);

	var _relocation2 = _interopRequireDefault(_relocation);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		//Messages
		_messages2.default.init();

		// Select 2
		_select2.default.init();

		// AdBlocker Detector
		_detectAdBlocker2.default.init();

		// Search
		_search2.default.init();

		// Jump to top
		_jumpToTop2.default.init();

		// Empty paragraphs
		_emptyParagraphs2.default.init();

		// Relocations
		_relocation2.default.init();

		// Calendar
		_calendar2.default.init();

		// Detect IE
		_detectIE2.default.init();

		// Archive navigation
		_archiveNav2.default.init();

		// Magazine Archive
		_magazineArchive2.default.init();

		// Letter Filter
		_letterFilter2.default.init();

		// Pagination
		_pagination2.default.init();

		// Input file
		_inputFile2.default.init();

		// Hide Empty Ads
		_hideEmptyAds2.default.init();

		// Ajax Complete
		_ajaxComplete2.default.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuNavMainMenu: $('.js-main-nav nav .menu'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		$domTopHeaderMenu: $('#block-topheadernavigation ul'),
		$stickyMenu: $('#block-psc-main-menu > ul'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(document).ready(function (e) {
				$('body').addClass('visible');
			});

			var scroll = Menu.$stickyMenu.offset().top;

			var body = _global2.default.$domBody;
			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domTopHeaderMenu.detach().appendTo(Menu.$domMenuNavMainMenu).addClass('d-lg-none');

				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-chevron d-lg-none" data-open-sub></span>');
				});
			}

			// Fading hamburger button
			if (_global2.default.varsWindowWidth < 992) {
				Menu.$stickyMenu.on('scroll', function () {
					if (Menu.$stickyMenu.scrollTop() === scroll) {
						$('.c-menu-btn').removeClass('button-invisible').addClass('button-visible');
					} else {
						$('.c-menu-btn').removeClass('button-visible').addClass('button-invisible');
					}
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: true,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: false,
				autoplaySpeed: 4000,
				prevArrow: "<span class='font-chevron previous'></span>",
				nextArrow: "<span class='font-chevron next'></span>",
				responsive: [{
					breakpoint: 767,
					settings: {
						dots: false
					}
				}]
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		$stickyMenu: $('.main-nav-wrapper'),
		$stickyMenuMobile: $('.layout-main-top'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			var prevScrollpos = window.pageYOffset;
			var page = Sticky.$content.scrollTop();
			// look at this

			window.onscroll = function () {

				var y = $(this).scrollTop();
				var currentScrollPos = window.pageYOffset;

				if (_global2.default.varsWindowWidth > 991) {
					if (y >= 180) {
						Sticky.$stickyMenu.addClass('sticky-header');
						Sticky.$content.addClass('sticky-content');
					} else {
						Sticky.$stickyMenu.removeClass('sticky-header');
						Sticky.$content.removeClass('sticky-content');
					}
				} else {
					if (y >= 230) {
						Sticky.$stickyMenuMobile.addClass('sticky-layout-main-top');
						Sticky.$content.addClass('sticky-content');
					} else {
						Sticky.$stickyMenuMobile.removeClass('sticky-layout-main-top');
						Sticky.$content.removeClass('sticky-content');
					}
				}
			};
		}
	};

	exports.default = Sticky;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}

			// Multilevel checkboxes
			if ($('.taxonomy-child').length) {
				$('.taxonomy-child').each(function (i, el) {
					$(el).parent().parent().addClass('has-sub-item');
				});
			}
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {
	    $statusMessages: $('body').find('div[aria-label*="Status message"]'),
	    $errorMessages: $('body').find('div[aria-label*="Error message"]'),
	    $warningMessages: $('body').find('div[aria-label="Warning message"]'),

	    init: function init() {
	        Messages.$statusMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$errorMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });

	        Messages.$warningMessages.on('click', function (e) {
	            var targetMessage = $(e.currentTarget);
	            targetMessage.addClass('hide');
	        });
	    }
	};

	exports.default = Messages;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 # Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),
		$domSortSelect: $('.form-item-sort-by').find('select'),
		$domSearchSubmit: $('.search-input-button-wrapper').find('#edit-submit-search'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder,
				minimumResultsForSearch: -1,
				width: '100%'
			});

			Select2.$domSortSelect.on('change', function () {
				Select2.$domSearchSubmit.click();
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Search = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domSearch: $('.search-wrapper-class').find('form').find('#edit-search-api-fulltext'),
	  $domSearchFormAction: $('.search-wrapper-class').find('form').find('.form-actions'),
	  $domSearchInput: $('.search-wrapper-class').find('form').find('.js-form-submit'),
	  $domForm: $('.search-wrapper-class').find('form'),
	  $domHeaderLogo: $('.c-branding'),
	  $domMainMenu: $('.c-main-navigation'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual

	    var body = _global2.default.$domBody;

	    body.on('click', function (e) {
	      if ($(e.target).closest(Search.$domForm).length == 0) {
	        Search.$domForm.removeClass('search');
	        Search.$domMainMenu.removeClass('search-visible');
	        $('.main-nav-wrapper').removeClass('search-visible');
	      }
	    });

	    Search.$domSearchFormAction.on('click', function (e) {
	      if ($('.main-nav-wrapper').hasClass('search-visible')) {
	        console.log($(e.target));
	        $(e.target).children('input').click();
	      }

	      $('.main-nav-wrapper').toggleClass('search-visible');

	      Search.$domForm.toggleClass('search');

	      if (_global2.default.varsWindowWidth < 500) {
	        Search.$domHeaderLogo.toggleClass('search-visible');
	      }

	      if (_global2.default.varsWindowWidth > 992 && _global2.default.varsWindowWidth < 1400) {
	        Search.$domMainMenu.toggleClass('search-visible');
	      }

	      Search.$domSearch.bind("change paste keyup", function () {

	        if (Search.$domSearch.val().length == 0) {
	          Search.$domSearchInput.removeClass('filled');
	        } else {
	          Search.$domSearchInput.addClass('filled');
	        }
	      });
	    });

	    // Search listing supplier logo detect

	    if ($('body').hasClass('page-search') && $('.search-results-logo').length) {

	      $('.search-results-logo').each(function (i, el) {
	        if ($(el).find('img').length) {
	          $(el).parent().addClass('supplier-has-logo');
	        }
	      });
	    }
	  }
	};

	exports.default = Search;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var JumpToTop = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $jumpToTop: $('.back-to-top-link'),
	  $formErrorToTop: $('.page-webform').find('.webform-button--submit'),
	  $formError: $('div[aria-label="Error message"]'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var offsetView = $('body').offset().top;

	    JumpToTop.$jumpToTop.on('click', function (e) {
	      e.preventDefault();
	      $([document.documentElement, document.body]).animate({
	        scrollTop: offsetView
	      }, 500);
	    });

	    JumpToTop.$formErrorToTop.on('click', function (e) {

	      if ($(_global2.default.$domBody).hasClass('toolbar-horizontal')) {
	        if ($(JumpToTop.$formError.length)) {
	          var viewTarget = $(e.currentTarget).closest('form');
	          var offsetView2 = viewTarget.offset().top - 350;

	          $(document).ajaxComplete(function () {

	            $([document.documentElement, document.body]).animate({
	              scrollTop: offsetView2
	            }, 400);
	          });
	        }
	      } else {
	        if ($(JumpToTop.$formError.length)) {
	          var _viewTarget = $(e.currentTarget).closest('form');
	          var _offsetView = _viewTarget.offset().top - 250;

	          $(document).ajaxComplete(function () {

	            $([document.documentElement, document.body]).animate({
	              scrollTop: _offsetView
	            }, 400);
	          });
	        }
	      }
	    });
	  }
	};

	exports.default = JumpToTop;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var EmptyParagraphs = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domParagraphs: $('p'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    // drupal fix for multilingual
	    // if(!$('body').hasClass('page-node-sponsor')) {
	    EmptyParagraphs.$domParagraphs.filter(function () {
	      var html = $(this).html();
	      if (html == '' || html == '&nbsp;') return true;
	    }).addClass('empty-paragraph');

	    EmptyParagraphs.$domParagraphs.filter(function () {
	      var html = $(this).html();
	      if (html == '' || html == '&nbsp;&nbsp;') return true;
	    }).addClass('empty-paragraph');
	    // }
	  }
	};

	exports.default = EmptyParagraphs;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var DetectIE = {

	  init: function init() {

	    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

	    if (isIE11) {
	      $('body').addClass('ie11');
	    }
	  }
	};

	exports.default = DetectIE;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var ArchiveNav = {
	  $domArchiveYear: $('.years-wrapper').find('.year-item'),
	  $domArchiveYearFirst: $('.years-wrapper').find('.year-item:first-of-type'),
	  $domheaderTitle: $('.view-archive'),
	  $archiveMonths: $('.archive-main-wrapper'),
	  $archiveLists: $('.archive-main-wrapper').find('ul'),
	  $archiveEventListMobile: $('.archive-main-wrapper').children('div'),

	  init: function init() {

	    ArchiveNav.$domArchiveYear.each(function () {

	      if ($(this).find('a').text() === ArchiveNav.$domheaderTitle.find('.view-header').text().trim()) {
	        $(this).children().addClass('active');
	        ArchiveNav.$domArchiveYearFirst.addClass('first-inactive');
	      }
	    });

	    ArchiveNav.$archiveMonths.find('.month').each(function () {
	      var monthContent = $(this).children('a').attr('class');
	      var listContent = ArchiveNav.$archiveLists.find('a').text();

	      if (listContent.indexOf(monthContent) != -1) {
	        $(this).addClass('has-events').css('color', 'red');
	      }
	    });

	    if (_global2.default.varsWindowWidth < 768) {
	      ArchiveNav.$archiveEventListMobile.children('.year').on('click', function (e) {
	        var self = $(e.currentTarget);
	        if (self.siblings('.month').is(':hidden')) {
	          self.siblings('.month').slideDown();
	          self.parent().addClass('menu-visible');
	          self.parent().siblings().removeClass('menu-visible');
	          self.parent().siblings().children('.month').slideUp();

	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 180
	            }, 400);
	          }, 350);
	        } else {
	          self.siblings('.month').slideUp();
	          self.parent().removeClass('menu-visible');
	        }
	      });
	    }
	  }
	};

	exports.default = ArchiveNav;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var MagazineArchive = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $magazineArchiveMenu: $('#block-magazinearchive > ul > li.menu-item--expanded'),
	  $magazineArchiveMenuFirst: $('#block-magazinearchive > ul > li.menu-item--expanded:first-of-type'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // bind events
	    if (_global2.default.varsWindowWidth < 992) {

	      MagazineArchive.$magazineArchiveMenuFirst.children('a').addClass('active');
	      MagazineArchive.$magazineArchiveMenuFirst.children('ul').addClass('active');

	      MagazineArchive.$magazineArchiveMenu.children('a').on('click', function (e) {
	        e.preventDefault();
	        var self = $(e.currentTarget);

	        if (!self.siblings('ul').hasClass('active')) {

	          MagazineArchive.$magazineArchiveMenu.children('ul').removeClass('active');
	          MagazineArchive.$magazineArchiveMenu.children('a').removeClass('active');
	          self.siblings('ul').addClass('active');
	          self.addClass('active');

	          setTimeout(function () {
	            $('html, body').animate({
	              scrollTop: $(self).offset().top - 270
	            }, 400);
	          }, 350);
	        } else {
	          self.removeClass('active');
	          self.siblings('ul').removeClass('active');
	        }
	      });
	    } else {
	      MagazineArchive.$magazineArchiveMenu.children('a').on('click', function (e) {
	        e.preventDefault();
	      });
	    }
	  }
	};

	exports.default = MagazineArchive;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var LetterFilter = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  $domLetterFilterActive: $('.view-display-id-attachment_1').find('span'),
	  $domLetterFilterDoubleContent: $('.views-element-container').parent().siblings('.view-content'),

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var href = location.href;

	    LetterFilter.$domLetterFilterActive.each(function () {
	      $(this).find('a').attr('disabled', false);

	      if ($(this).find('a').text() == href.match(/([^\/]*)\/*$/)[1]) {
	        $(this).addClass('active-item');
	        LetterFilter.$domLetterFilterDoubleContent.hide();
	      } else {
	        LetterFilter.$domLetterFilterActive.last().addClass('active-item');
	      }
	    });
	  }
	};

	exports.default = LetterFilter;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Pagination = {
	  /*-------------------------------------------------------------------------------
	  # Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {
	    var pagerItem = $('.pager').find('.pager__item > a');

	    if (_global2.default.$domBody.hasClass('page-useful-links')) {
	      pagerItem.on('click', function (e) {
	        var viewTarget = $(e.currentTarget).closest('.views-element-container');
	        var offsetView = viewTarget.offset().top - 200;
	        console.log();

	        $(document).ajaxComplete(function () {

	          $([document.documentElement, document.body]).animate({
	            scrollTop: offsetView
	          }, 100);
	        });
	      });
	    }
	  }
	};

	exports.default = Pagination;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var AdBlockerDetector = {
	  /*-------------------------------------------------------------------------------
	  	# Cache dom and strings
	  -------------------------------------------------------------------------------*/

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var adBlockEnabled = false;
	    var testAd = document.createElement('div');
	    testAd.innerHTML = '&nbsp;';
	    testAd.className = 'adsbox';
	    document.body.appendChild(testAd);
	    window.setTimeout(function () {
	      if (testAd.offsetHeight === 0) {
	        adBlockEnabled = true;
	        $('body').addClass('adblocker-enabled');
	      } else {
	        $('body').addClass('adblocker-disabled');
	      }
	      testAd.remove();
	    }, 100);
	  }
	};

	exports.default = AdBlockerDetector;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var InputFile = {

	  $inputFile: $('input[type="file"]'),

	  init: function init() {

	    InputFile.$inputFile.each(function () {
	      $(this).after('<div class="custom-upload-file">Choose photo</div>');
	    });
	  }
	};

	exports.default = InputFile;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var HideAds = {

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/

	  init: function init() {

	    $(window).bind("load", function () {
	      // ADD-ON js solution
	      var googleAdd = $('.news-listing-ad-wrapper').find('div[id*="google_ads_iframe_"]');
	      setTimeout(function () {
	        googleAdd.each(function (index, el) {

	          if ($(el).html().length > 0) {
	            $(el).parent().addClass('not-empty');
	          } else {
	            $(el).parent().remove();
	            $(el).closest('.field-body').remove();
	          }
	        });
	      }, 500);
	    });

	    var googleAdd = $('.news-listing-ad-wrapper').find('div[id*="google_ads_iframe_"]');
	    setTimeout(function () {
	      googleAdd.each(function (index, el) {

	        if ($(el).html().length > 0) {
	          $(el).parent().addClass('not-empty');
	        } else {
	          $(el).parent().remove();
	          $(el).closest('.field-body').remove();
	        }
	      });
	    }, 500);
	  }
	};

	exports.default = HideAds;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _inputFile = __webpack_require__(17);

	var _inputFile2 = _interopRequireDefault(_inputFile);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line

	var AjaxComplete = {

		init: function init() {

			$(document).ajaxComplete(function () {
				_inputFile2.default.init();
			});
		}
	};

	exports.default = AjaxComplete;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var $ = jQuery.noConflict();

	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Calendar = {

	  $calendar: $('.js-drupal-fullcalendar'),
	  $zero: $('.fc-basicDay-view').find('.fc-content-skeleton').find('td'),
	  // $archiveMonths : $('.archive-main-wrapper'),
	  // $archiveLists: $('.archive-main-wrapper').find('ul'),
	  // $archiveEventListMobile: $('.archive-main-wrapper').children('div'),

	  init: function init() {

	    if ($('.webinar-join-link').length) {

	      $('.webinar-join-link').find('a').wrap('<div class="webinar-link-wrapper"></div>');
	    }

	    var zeroState = $('.fc-basicDay-view').find('.fc-content-skeleton').find('tbody').find('tr');
	    var calendarTitle = $('.js-drupal-fullcalendar').find('.fc-left').find('h2');

	    if (Calendar.$calendar.length) {
	      var _Calendar$$calendar$f;

	      Calendar.$calendar.fullCalendar('destroy');
	      $('body').addClass('table-styling');

	      Calendar.$calendar.fullCalendar((_Calendar$$calendar$f = {

	        footer: {
	          left: 'title',
	          center: 'month',
	          right: 'prev,next'
	        },
	        firstDay: 1,
	        defaultDate: drupalSettings.defaultDate,
	        locale: drupalSettings.defaultLang,
	        navLinks: drupalSettings.navLinks == 0 ? false : true,
	        editable: true,
	        eventLimit: false,
	        events: drupalSettings.fullCalendarView,
	        eventOverlap: false,
	        timeFormat: 'H:mm',
	        contentHeight: 'auto'
	      }, _defineProperty(_Calendar$$calendar$f, 'contentHeight', function contentHeight() {
	        // if (Global.varsWindowWidth < 991) {
	        //   return 500;
	        // }
	      }), _defineProperty(_Calendar$$calendar$f, 'eventAfterAllRender', function eventAfterAllRender() {
	        $('.js-drupal-fullcalendar').addClass('loaded');

	        if ($('.fc-basicDay-view').find('.fc-content-skeleton').height() < 20) {
	          $('td:empty:first').each(function (i, item) {
	            $(this).addClass('empty-cell').append('<p class="zero-state">There are no events for this day</p>');
	          });
	        }

	        $('.fc-month-button').html('Month view');
	        $('.fc-month-view').parent().addClass('month-view-parent');

	        $('.fc-day-top').not('.fc-other-month').each(function () {
	          $(this).on('click', function (e) {
	            $('.fc-month-view').parent().removeClass('month-view-parent');
	          });
	        });

	        if (window.innerWidth < 991) {
	          Calendar.$calendar.css('height', '500px');
	        }

	        Calendar.$calendar.find('.fc-left').find('h2').each(function () {
	          var elText,
	              openSpan = '<span class="month">',
	              closeSpan = '</span>';
	          elText = $(this).text().split(" ");
	          elText.unshift(openSpan);
	          elText.splice(2, 0, closeSpan);
	          elText = elText.join(" ");
	          $(this).html(elText);
	        });
	      }), _defineProperty(_Calendar$$calendar$f, 'eventRender', function eventRender(event, element) {
	        var dataToFind = moment(event.start).format('YYYY-MM-DD');
	        $("td[data-date='" + dataToFind + "']").addClass('activeDay');
	      }), _Calendar$$calendar$f));
	    }

	    // Calendar.$archiveMonths.find('.month').each(function() {
	    //   var monthContent = $(this).children('a').attr('class')
	    //   var listContent = Calendar.$archiveLists.find('a').text();
	    //
	    //   if(listContent.indexOf(monthContent) != -1) {
	    //     $(this).addClass('has-events');
	    //   }
	    // });
	    //
	    //
	    // if (Global.varsWindowWidth < 576 || Global.varsWindowWidth > 991 && Global.varsWindowWidth < 1150) {
	    //   Calendar.$archiveEventListMobile.children('.year').on('click', e => {
	    //     const self = $(e.currentTarget);
	    //     if(self.siblings('.month').is(':hidden')) {
	    //       self.siblings('.month').slideDown();
	    //       self.parent().addClass('menu-visible');
	    //       self.parent().siblings().removeClass('menu-visible');
	    //       self.parent().siblings().children('.month').slideUp();
	    //     }
	    //
	    //     else {
	    //       self.siblings('.month').slideUp();
	    //       self.parent().removeClass('menu-visible');
	    //     }
	    //   });
	    // }
	  }
	};

	exports.default = Calendar;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Relocation = {

	  init: function init() {

	    if ($('body').hasClass('page-node-19814') || $('body').hasClass('page-node-20161') || $('body').hasClass('page-node-17176') || $('body').hasClass('page-node-25331')) {

	      $('body').addClass('plant-based-week-page');

	      $('.c-share').detach().appendTo('#site-content');
	      $('.c-share').children().wrapAll('<div class="container"></div>');

	      if ($('.field--name-field-center-text').length && $('.field--name-field-center-text').find(':header').length) {
	        $('.field--name-field-center-text').find(':header').addClass('field-center-title');
	      }

	      $('.field--type-entity-reference-revisions > .field--items > .field--item').last().addClass('field--item-last');
	    }
	  }
	};

	exports.default = Relocation;

/***/ })
/******/ ]);